import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "dropdown" }
const _hoisted_2 = ["aria-label", "title"]
const _hoisted_3 = ["lang"]
const _hoisted_4 = { class: "dropdown-menu dropdown-menu-end ui-lang-menu" }
const _hoisted_5 = { class: "ui-lang-head" }
const _hoisted_6 = ["aria-pressed", "onClick"]
const _hoisted_7 = ["lang"]
const _hoisted_8 = ["lang"]
const _hoisted_9 = {
  key: 0,
  class: "ph ph-check ui-lang-item-check",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "ui-icon-btn ui-lang-toggle",
      type: "button",
      "data-bs-toggle": "dropdown",
      "data-bs-display": "static",
      "aria-expanded": "false",
      "aria-label": _ctx.$t('header.language'),
      title: _ctx.$t('header.language')
    }, [
      _createElementVNode("span", {
        class: "ui-lang-code",
        lang: _ctx.current.code
      }, _toDisplayString(_ctx.current.short), 9, _hoisted_3)
    ], 8, _hoisted_2),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("header.language")), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locales, (l) => {
        return (_openBlock(), _createElementBlock("button", {
          key: l.code,
          type: "button",
          class: _normalizeClass(["dropdown-item ui-lang-item", { active: l.code === _ctx.current.code }]),
          "aria-pressed": l.code === _ctx.current.code,
          onClick: ($event: any) => (_ctx.choose(l.code))
        }, [
          _createElementVNode("span", {
            class: "ui-lang-item-code",
            lang: l.code
          }, _toDisplayString(l.short), 9, _hoisted_7),
          _createElementVNode("span", {
            class: "ui-lang-item-label",
            lang: l.code
          }, _toDisplayString(l.label), 9, _hoisted_8),
          (l.code === _ctx.current.code)
            ? (_openBlock(), _createElementBlock("i", _hoisted_9))
            : _createCommentVNode("", true)
        ], 10, _hoisted_6))
      }), 128))
    ])
  ]))
}